<template>
  <e-btn icon variant="ghost" size="M" class="mr-2 mr-md-4">
    <e-icon name="bell" />
  </e-btn>

  <default-layout-menu-dialog v-if="$vuetify.display.mdAndDown" />
  <v-menu v-model="isMenuOpened" v-else offset="6">
    <template #activator="{ props }">
      <profile-button v-bind="props" />
    </template>
    <v-card class="default-layout-menu">
      <default-layout-menu show-profile-menu @item-click="closeMenu" />
    </v-card>
  </v-menu>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { EBtn, EIcon } from '@/core/components/ui';
import ProfileButton from '@/core/layouts/components/ProfileButton.vue';
import DefaultLayoutMenu from '@/core/layouts/components/default/DefaultLayoutMenu.vue';
import DefaultLayoutMenuDialog from '@/core/layouts/components/default/DefaultLayoutMenuDialog.vue';

const isMenuOpened = ref(false);

const closeMenu = () => {
  isMenuOpened.value = false;
};
</script>

<style scoped lang="scss">
.default-layout-menu {
  width: 280px;
  padding: 15px 22px;
}
</style>
